import { useRouter } from 'next/router';

import type { FC } from 'react';

/**
 * Fixed indicator rendered only while Next.js Preview Mode is active (see
 * pages/api/draft-preview.ts), so whoever follows a preview link can tell they
 * are looking at draft header/footer/announcement-bar content and has a
 * one-click way back to published content. Plain <a> on purpose: the exit API
 * route must run server-side to clear the preview cookies.
 */
const DraftPreviewBadge: FC = () => {
  const { asPath } = useRouter();

  return (
    <a
      className="fixed bottom-4 left-4 z-50 rounded-full bg-warning-300 px-4 py-2 text-sm font-semibold text-gray-900 shadow-lg hover:bg-warning-200"
      href={`/api/exit-draft-preview?path=${encodeURIComponent(asPath)}`}
    >
      Draft preview on. Click to exit
    </a>
  );
};

export default DraftPreviewBadge;
